import { render, staticRenderFns } from "./DialogIdentify.vue?vue&type=template&id=284f7c4e&scoped=true"
import script from "./DialogIdentify.vue?vue&type=script&lang=ts"
export * from "./DialogIdentify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284f7c4e",
  null
  
)

export default component.exports